import * as React from 'react';
import { Grid, Dropdown, Popup, Icon } from 'semantic-grab-ui/src';
import { getNodePopupContent, getDefaultNodeName } from 'omega-rtc/utils/trident-node-utils';
import _ from 'lodash';
import './WidgetComponent.scss';
import { CampaignWidgetProps } from 'types/ts/campaigns';
import { nodeTypes } from 'data/trident-types';
import { preOrderTraversalFromCurrentNodeToItsChildren, renderDropdownItem, getNodeTypeChildOptions } from './util';

export default class TimeWidget extends React.Component<CampaignWidgetProps> {
  render() {
    const { model, currentNodeKey } = this.props;
    const gridStyle = {
      width: 'auto',
    };
    const gridStyleForAddButton = {
      width: 'auto',
      top: 45,
      right: 25,
    };
    const addButtonSize = {
      fontSize: '1.5em',
      marginTop: '-10px',
      color: '#3498DB',
    };
    const noOfChildren = _.get(model.nodes[currentNodeKey], 'children', []).length;
    const renderAddButton = noOfChildren === 0;

    // check wheather flow is completed or not, it will help to render add button with set of options after flow completed.
    const flowCompleted = preOrderTraversalFromCurrentNodeToItsChildren(model, currentNodeKey, true);
    const addButtonAfterFlow = noOfChildren !== 0 && flowCompleted;
    const defaultName = getDefaultNodeName(currentNodeKey, nodeTypes.time, _.get(model, 'nodesOccMap'));
    const childOptions = getNodeTypeChildOptions(model.targetUserType,nodeTypes.time);

    return (
      <Grid>
        <Grid.Column style={gridStyle}>
          <Popup
            trigger={
              <div onClick={() => this.props.handleNodePreview([currentNodeKey], currentNodeKey)}>
                <div className={this.props.clickedNode === this.props.currentNodeKey ? 'div1StyleClicked' : 'div1Style'} />
                <div className={this.props.clickedNode === this.props.currentNodeKey ? 'div2StyleClicked' : 'div2Style'}>
                  <p className="p">{_.get(this.props.model.nodes[this.props.currentNodeKey], 'name', defaultName) || defaultName}</p>
                </div>
                <div className={this.props.clickedNode === this.props.currentNodeKey ? 'div3StyleClicked' : 'div3Style'} />
              </div>
            }
            content={getNodePopupContent(this.props.model, 'name', this.props.currentNodeKey, defaultName)}
          />
        </Grid.Column>
        {(renderAddButton || addButtonAfterFlow) &&
          <Grid.Column style={gridStyleForAddButton}>
            <Dropdown icon="plus square" floating basic className="icon" style={addButtonSize}>
              <Dropdown.Menu>
                {childOptions.map(option =>
                  renderDropdownItem(`Add ${option}`, () => this.props.handleAddNode(option, currentNodeKey, [currentNodeKey]))
                )}
              </Dropdown.Menu>
            </Dropdown>
          </Grid.Column>
        }
      </Grid>
    );
  }
}
